import { REZERVATION_REQUEST } from '@/plugins/rezzervation'
export default {
  data() {
    return {
      loadingPurchase: false,
      iframeLink: '',
      successTransfer: false,
      alertBox: {
        status: false,
        message: '',
        variant: '',
      },
    }
  },
  props: {
    product: {
      default: () => {},
    },
    item: {
      default: () => {},
    },
    date: {
      default: () => {},
    },
    time: {
      default: '',
    },
  },
  methods: {
    SET_ALERT_BOX(message, variant) {
      this.alertBox = {
        status: true,
        message,
        variant,
      }
      setTimeout(() => {
        this.alertBox.status = false
      }, 10000)
    },
    async SEND_REZ(callback, CustomerPackageId = null) {
      this.loadingPurchase = true
      const response = await REZERVATION_REQUEST(
        'Customers/CreateRez',
        'post',
        {
          RoomId: this.item.department.Id,
          CustomerId: this.item.Id,
          Note: this.item.Note,
          Price: this.item.Price,
          Duration: this.item.Duration,
          Processes: this.item.Processes.map((p) => p.Id).join(','),
          RezervationDate: this.date.val,
          RezervationTime: this.time,
          Currency: this.item.userIp.currency,
          CustomerPackageId,
        },
        {
          Authorization: `Bearer ${this.item.Token}`,
          'Content-Type': 'application/json',
        }
      )
      if (response.message === 'OK' && callback) {
        callback(response.data)
      } else if (response.message === 'OK') {
        this.$emit('update:step', 3, response.data)
      } else if (response.message === 'REGISTERED') this.$emit('update:step', 5)
      else this.$emit('update:step', 4)
    },
    async SEND_REZ_WITH_IYZICO(rezId) {
      this.iframeLink = ''
      this.successTransfer = false
      this.SET_ALERT_BOX(this.$custom$t('connectionToIyzico'), 'success')
      const response = await REZERVATION_REQUEST(
        'Payments/Iyzico',
        'post',
        {
          RezervationId: rezId,
          IsSms: 0,
          IsEmail: 0,
        },
        {
          Authorization: `Bearer ${this.item.Token}`,
          'Content-Type': 'application/json',
        }
      )
      if (response.message === 'OK') {
        this.iframeLink = response.data
        this.SET_ALERT_BOX(this.$custom$t('actionIsContiuning'), 'success')
      } else {
        this.SET_ALERT_BOX(this.$custom$t('actionIsError'), 'danger')
      }
      this.loadingPurchase = false
    },
    async SEND_REZ_WITH_PAYPAL(rezId) {
      this.iframeLink = ''
      this.successTransfer = false
      this.SET_ALERT_BOX(this.$custom$t('connectionToPaypal'), 'success')
      const response = await REZERVATION_REQUEST(
        'Payments/Paypal',
        'post',
        {
          RezervationId: rezId,
          IsSms: 0,
          IsEmail: 0,
        },
        {
          Authorization: `Bearer ${this.item.Token}`,
          'Content-Type': 'application/json',
        }
      )
      if (response.message === 'OK') {
        this.iframeLink = response.data
        this.SET_ALERT_BOX(this.$custom$t('actionIsContiuning'), 'success')
      } else {
        this.SET_ALERT_BOX(this.$custom$t('actionIsError'), 'danger')
      }
      this.loadingPurchase = false
    },
    async SEND_REZ_WITH_TRANSFER(rezId) {
      this.iframeLink = ''
      this.SET_ALERT_BOX(this.$custom$t('actionIsContiuning'), 'success')
      this.successTransfer = false
      const response = await REZERVATION_REQUEST(
        'Payments/Transfer',
        'post',
        {
          RezervationId: rezId,
          IsSms: 0,
          IsEmail: 1,
        },
        {
          Authorization: `Bearer ${this.item.Token}`,
          'Content-Type': 'application/json',
        }
      )
      if (response.message === 'OK') {
        this.iframeLink = ''
        this.SET_ALERT_BOX(this.$custom$t('actionIsDone'), 'success')
        this.$store.dispatch('profile.seances/SEND_TO_ADD_USERS_SEANCE', {
          api: {
            data: Number(rezId),
          },
          Id: this.item.Id,
          ProcessesData: this.item.department.Processes.map((p) => p.Id).join(
            ','
          ),
          currency: this.item.userIp.currency,
          appointment: this.item,
          seance: this.product,
        })
        this.successTransfer = true
      } else {
        this.SET_ALERT_BOX(this.$custom$t('actionIsError'), 'danger')
      }
      this.loadingPurchase = false
    },
  },
}
